import { Link, useNavigate } from 'react-router-dom';
import { Sun, Moon, LogOut, User, BookOpen } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import { Button } from './ui/button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from './ui/dropdown-menu';

export function Header() {
    const { user, logout } = useAuth();
    const { theme, toggleTheme } = useTheme();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    return (
        <header 
            data-testid="header"
            className="fixed top-0 left-0 right-0 z-50 glass-header"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <div className="flex items-center justify-between h-16">
                    <Link 
                        to="/dashboard" 
                        data-testid="logo-link"
                        className="flex items-center gap-3 group"
                    >
                        <div className="w-8 h-8 bg-primary flex items-center justify-center">
                            <BookOpen className="w-5 h-5 text-primary-foreground" strokeWidth={1.5} />
                        </div>
                        <span className="font-serif text-xl tracking-tight text-foreground">
                            flashKard
                        </span>
                    </Link>

                    <div className="flex items-center gap-4">
                        <Button
                            variant="ghost"
                            size="icon"
                            onClick={toggleTheme}
                            data-testid="theme-toggle"
                            className="btn-lift"
                        >
                            {theme === 'light' ? (
                                <Moon className="w-5 h-5" strokeWidth={1.5} />
                            ) : (
                                <Sun className="w-5 h-5" strokeWidth={1.5} />
                            )}
                        </Button>

                        {user && (
                            <DropdownMenu>
                                <DropdownMenuTrigger asChild>
                                    <Button 
                                        variant="ghost" 
                                        data-testid="user-menu-trigger"
                                        className="flex items-center gap-2 btn-lift"
                                    >
                                        <div className="w-8 h-8 bg-secondary flex items-center justify-center">
                                            <User className="w-4 h-4" strokeWidth={1.5} />
                                        </div>
                                        <span className="hidden sm:inline font-sans text-sm">
                                            {user.name}
                                        </span>
                                    </Button>
                                </DropdownMenuTrigger>
                                <DropdownMenuContent align="end" className="w-48">
                                    <DropdownMenuItem disabled className="font-mono text-xs text-muted-foreground">
                                        {user.email}
                                    </DropdownMenuItem>
                                    <DropdownMenuSeparator />
                                    <DropdownMenuItem 
                                        onClick={handleLogout}
                                        data-testid="logout-button"
                                        className="text-destructive focus:text-destructive cursor-pointer"
                                    >
                                        <LogOut className="w-4 h-4 mr-2" strokeWidth={1.5} />
                                        Log out
                                    </DropdownMenuItem>
                                </DropdownMenuContent>
                            </DropdownMenu>
                        )}
                    </div>
                </div>
            </div>
        </header>
    );
}
